import request, { baseURL, METHODS } from '@/api'
import {Button, Drawer, Input, Radio} from 'antd'
import { useEffect, useRef, useState } from 'react'
import {SDrawerOrModal, SEditor, SFormUploadImage, SGeneralForms, SSegmentedTabs} from 'shj-components'

import { divide, isEmpty } from 'lodash-es'
import { trimStr } from '@/utils/data.ts'
import { getEnums } from '@/services/homeService.ts'
import { AcceptType } from 'shj-components/dist/es/SFormUploadImage'
import styles from './index.module.less'
import { uploadFile } from '@/services'
import PDFPreview from '@/components/PDFPreview'

interface Iprops {
  open: boolean
  onCancel?: () => void
  title: string
  record?: any
  onConfirm: (values: any) => Promise<any>
  filedShowName?: string
}

export default function DrawerToTab(props: Iprops) {
  const { open, onCancel, title, onConfirm, record, filedShowName } = props
  const [tabs, setTabs] = useState<any[]>([])
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  const [fileUrl, setFileUrl] = useState<any>(undefined)
  const formRef = useRef<any>()
  useEffect(() => {
    if (open) {
      getTabs()
    } else {
      onFormRef()?.resetFields()
    }
  }, [open])

  const getTabs = async () => {
    const tabs = await getEnums('plus-goods', 'com.shj.saas.plus.goods.enums.FileSubTypeEnum')
    setTabs(tabs?.map(item => ({ label: item.description, value: item.key })))
  }

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    if (open && tabs.length) {
      if (!isEmpty(record)) {
        const url =
          record.urlSite && record.subBusType !== 'TYPE_DESIGN'
            ? [
                {
                  url: record.urlSite,
                  name: record?.subBusType === 'TYPE_PDF' ? 'PDF文件' : '视频',
                },
              ]
            : record.urlSite
        setFileUrl(record.urlSite)
        onFormRef()?.setFieldsValue({
          ...record,
          urlSite: url,
        })
      } else {
        onFormRef()?.setFieldValue('subBusType', tabs[0]?.value)
      }
    }
  }, [open, tabs, record])

  const onChangeFile = file => {
    if (!isEmpty(file)) {
      let fileUrl
      const item = file[0]
      if (item.status === 'done' && item.response.data) {
        fileUrl = item.response.data.fileUrl
      }
      setFileUrl(fileUrl)
    } else {
      setFileUrl(undefined)
    }
  }

  const onEditorUpload = async obj => {
    const { blobInfo, succFun, failFun } = obj
    const dataForm = new FormData()
    dataForm.append('file', blobInfo.blob(), blobInfo.filename())
    uploadFile(dataForm)
      .then(res => {
        succFun(`${res?.fileUrl}`)
      })
      .catch(failFun)
  }
  // 自定义预览方式
  const handlePreview = file => {
    console.log(file)
    window.open(file.response?.data?.fileUrl || file.url)
  }
  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setBtnLoading(true)
        const newValues = {
          ...values,
          urlSite: values.subBusType !== 'TYPE_DESIGN' ? fileUrl : values.urlSite,
          attachPath: values.subBusType !== 'TYPE_DESIGN' ? fileUrl : values.urlSite,
        }
        onConfirm(newValues).finally(() => setBtnLoading(false))
      })
  }
  return (
    <SDrawerOrModal
      title={title}
      open={open}
      onCancel={onCancel}
      destroyOnClose
      width={500}
      className={styles.second_drawer}
      antdProps={{
        footer: <div style={{ textAlign: 'right' }}>
          <Button loading={btnLoading} style={{ marginRight: '10px' }} onClick={onCancel}>
            取消
          </Button>
          <Button loading={btnLoading} type="primary" onClick={onsubmit}>
            保存
          </Button>
        </div>
      }}
    >
      <div style={{margin: '0 10px'}}>
      <SGeneralForms
        ref={formRef}
        initialValues={record.id ? { subBusType: record.subBusType } : {}}
        // httpOptionsFn={getOptions}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              { name: 'id', hidden: true },
              { name: 'key', hidden: true },
              {
                label: '标题',
                name: 'name',
                spanCol: 24,
                required: true,
                rules: [{ required: true, message: '标题不能为空' }],
                comConfig: {
                  maxLength: 6,
                  showCount: true,
                  onChange: e => onFormRef()?.setFieldValue('name', trimStr(e.target.value)),
                  style: {width: 460}
                },
              },
              {
                spanCol: 24,
                required: true,
                name: 'subBusType',
                label: filedShowName || '详情类型',
                children: (
                  <Radio.Group
                    options={tabs}
                    onChange={(e: any) => {
                      setFileUrl(undefined)
                      onFormRef()?.setFieldsValue({
                        subBusType: e.target.value,
                        contentInfo: '',
                        urlSite: undefined,
                      })
                    }}
                    style={{ padding: 0 }}
                    tabBarStyles={{
                      width: 'max-content',
                    }}
                  />
                ),
              },
              {
                spanCol: 24,
                required: true,
                rules: [{ required: true, message: '内容不能为空' }],
                name: 'contentInfo',
                label: '内容',
                isDeps: true,
                deps: form => form.getFieldValue('subBusType') === 'TYPE_TXT',
                children: (
                  <SEditor
                    toolbar="fullscreen | undo redo | styleselect fontselect fontsizeselect | bold italic lineheight strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify  | numlist bullist | indent2em outdent indent | subscript superscript | charmap image removeformat | link"
                    onUpload={onEditorUpload}
                  />
                ),
              },
              {
                name: 'urlSite',
                label: '内容',
                required: true,
                rules: [{ required: true, message: '内容不能为空' }],
                isDeps: true,
                deps: form => form.getFieldValue('subBusType') === 'TYPE_PDF',
                children: (
                  <SFormUploadImage
                    url={baseURL + 'file-web/file/upload'}
                    limit={1}
                    accept={AcceptType.pdf}
                    handlePreview={file => handlePreview(file)}
                    onChange={file => onChangeFile(file)}
                  />
                ),
                spanCol: 20,
              },
              {
                name: 'urlSite',
                label: '内容',
                required: true,
                rules: [{ required: true, message: '内容不能为空' }],
                isDeps: true,
                deps: form => form.getFieldValue('subBusType') === 'TYPE_VIDEO',
                children: (
                  <SFormUploadImage
                    url={baseURL + 'file-web/file/upload'}
                    limit={1}
                    accept={AcceptType.video}
                    previewType="video"
                    onChange={file => onChangeFile(file)}
                    timeout={1000 * 60 * 10}
                  />
                ),
                spanCol: 20,
              },
              {
                name: 'urlSite',
                label: '内容',
                required: true,
                rules: [{ required: true, message: '内容不能为空' }],
                isDeps: true,
                deps: form => form.getFieldValue('subBusType') === 'TYPE_DESIGN',
                spanCol: 24,
                type: 'textarea',
                comConfig: {
                  style: {width: 460}
                }
              },
            ],
          },
        ]}
      />
      </div>
    </SDrawerOrModal>
  )
}
